class FeaturedProductsSlider {
    constructor(container, options) {
      this.container = container;
      this.options = options;
      this.splide = null;
      this.mediaQuery = window.matchMedia('(max-width: 1023px)');
      this.init();
    }
  
    init() {
      this.initializeSlider();
      this.handleMediaQueryChange();
    }
  
    initializeSlider() {
      if (this.mediaQuery.matches && !this.splide) {
        this.splide = new Splide(this.container, this.options);
  
        this.splide.on('mounted move', () => {
          const slides = document.querySelectorAll(`${this.container} .splide__slide`);
          const lastSlide = slides[slides.length - 1];
  
          slides.forEach((slide) => slide.classList.remove('is-last'));
  
          if (this.splide.index === slides.length - this.splide.options.perPage) {
            lastSlide.classList.add('is-last');
          }
        });
  
        this.splide.mount();
      }
    }
  
    handleMediaQueryChange() {
      this.mediaQuery.addListener((e) => {
        if (e.matches) {
          this.initializeSlider();
        } else {
          this.destroySlider();
        }
      });
    }
  
    destroySlider() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
      }
    }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    new FeaturedProductsSlider('.featured-products-section .splide', {
      perPage: 3,
      pagination: true,
      arrows: false,
      breakpoints: {
        1023: {
          destroy: false,
          perPage: 1,
        },
        768: {
          perPage: 1,
        },
      },
    });
  });
  